module.exports = __webpack_public_path__ + "static/media/mockPhoto1.4cf7d6c4.jpg";